import { useState, useEffect } from "react";
import * as React from 'react';
import {Container, Grid, FormControl, Icon} from '@mui/material';

import SectionSpinner from '../Loading/SectionSpinner/SectionSpinner';
import OutlinedButton from '../Button/OutlinedButton/OutlinedButton';
import UserList from "./UserList";
import DeviceList from "./DeviceList";
import ChallengeList from "./ChallengeList";
import AddUserModal from "./AddUserModal";
import SettingsModal from "./SettingsModal";
import QueueModal from "./QueueModal";

import "./ControlForm.css";
import Logo from '../../assets/images/rezzil-logo-full.png';
import { color } from "@mui/system";




function ControlForm(props){

    const [loading, setLoading] = useState(true);
    const [formDisabled, setFormDisabled] = useState(true);
    const [connectionError, setConnectionError] = useState({"has_error":false, "msg":""});

    const [devices, setDevices] = useState([]);
    const [challenges, setChallenges] = useState([]);
    const [users, setUsers] = useState([]);

    // Form inputs:
    const [device, setDevice] = useState('');
    const [challenge, setChallenge] = useState('');
    const [user, setUser] = useState('');

    const handleDeviceChange = (event) => {
        setDevice(event.target.value);
    };

    const handleChallengeChange = (event) => {
        setChallenge(event.target.value);
    };

    const handleUserChange = (event, user_id) => {
        // Allows us to unset if we tap the same user again.
        if(user_id !== user){
            setUser(user_id);
        }else{
            setUser('');
        }
    };

    function checkFormData(){
        if( (device !== "") && (challenge !== "") && (user !== "")){
            setFormDisabled(false);
        }else{
            setFormDisabled(true);
        }
    }

    async function handleSubmit(){
        setLoading(true);

        var new_session_data = {
            deviceId: device,
            challengeId: challenge,
            userId: user
        }

        return fetch(process.env.REACT_APP_API_ENDPOINT+'squadslive/goLive', {
            method: 'POST',
            headers: {
                'Authorization': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(new_session_data)
        })
        .then(res => res.json())
        .then(function (response){    
            if(response.code === 200){

                console.log(response);
                
                resetForm();

                return true;

            }else{
                console.log("An error occured processing the data.");
                return false;
            }        
        })
    }

    function resetForm(){
        // Reset to the first items in the lists and null out the user selection.
        setDevice(devices[0].id);
        setChallenge(challenges[0].id);
        setUser('');
        setLoading(false);
    }

    function addUser(new_user_data){
        setUsers([...users, new_user_data]);
        // Select the new user by default
        setUser(new_user_data.id);
    }

    function updateDevices(data){
        console.log("[LOG] Update devices called.");

        var updated_device = data.data;

        var new_devices = [];

        devices.forEach(device => {
            if(device.id === updated_device.id){
                device.label = updated_device.label;
            }

            new_devices.push(device);
        });

        console.log("[LOG] Updated devices:");
        console.log(new_devices);
        setDevices(new_devices);

    }

    useEffect(() => {
        checkFormData();
    },[device, challenge, user])


    async function getControlConfig(){
        
        var config_url = process.env.REACT_APP_API_ENDPOINT + "squadslive/init";

        setLoading(true);
        
        try {
            const res = await fetch(config_url, {
                method: 'GET',
                headers: {
                    'Authorization': localStorage.getItem('token'),
                    'Content-Type': 'application/json'
                }
            });
            const data = await res.json();
            if (data.code === 200) {
                setDevices(data.data.devices);
                setChallenges(data.data.challenges);
                setUsers(data.data.users);
    
                // Set default items so that MUI is happy.
                if(data.data.devices.length>0){
                    setDevice(data.data.devices[0].id);
                }

                if(data.data.challenges.length>0){
                    setChallenge(data.data.challenges[0].id);
                }
    
                setLoading(false);
            } else {
    
                if (data.error === "AUTHORISATION ISSUE") {
                    console.log("[LOG] Invalid token.");
                }
    
                console.log("An error occured loading the config.");
                return false;
            }
        } catch (error) {
            console.log(error);
            console.log("Couldn't create a connection to the server.");
            setConnectionError({"has_error":true, "msg":"We couldn't connect to the server. Please make sure you are connected to the internet."});
            setLoading(false);
        }

        

        

    }

    useEffect(() => {
        document.title = 'Control - Rezzil Squads Live';
        getControlConfig();
    }, [])

    function reload(){
        window.location.reload(false);
    }

    if(connectionError.has_error){
        return(
            <>
                <div id="common-nav">
                    <Container fixed>
                        <Grid container spacing={2}>
                            <Grid item xs={10}>
                                <img src={Logo} alt='Rezzil Logo' id="common-nav-logo"/>
                            </Grid>
                            <Grid item xs={2}>
                                
                            </Grid>
                        </Grid>
                    </Container>
                </div>
                <Container
                    fixed
                    sx={{ 
                        mt: "100px"
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sx={{textAlign:'center'}}>
                            <h1 style={{color: '#ffffff'}}>{connectionError.msg}</h1>
                            <OutlinedButton
                                text={'Retry'}
                                onClick={reload}
                            />
                        </Grid>
                    </Grid>
                </Container>
            </>
        )
    }
    else{

        return(
            <>
                <div id="common-nav">
                    <Container fixed>
                        <Grid container spacing={2}>
                            <Grid item xs={8}>
                                <img src={Logo} alt='Rezzil Logo' id="common-nav-logo"/>
                            </Grid>
                            <Grid item xs={4} sx={{textAlign:'right'}}>
                                <SettingsModal devices={devices} updateDevices={updateDevices} />
                                <QueueModal />
                            </Grid>
                        </Grid>
                    </Container>
                </div>
                <Container
                    fixed
                    sx={{ 
                        mt: "100px"
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>

                                <DeviceList items={devices} handleChange={handleDeviceChange} selectedItem={device} loadingState={loading}/>
                                
                                <ChallengeList items={challenges} handleChange={handleChallengeChange} selectedItem={challenge} loadingState={loading}/>

                                <AddUserModal returnNewUser={addUser} loadingState={loading}/>

                                <UserList users={users} handleUserChange={handleUserChange} selectedUser={user} loadingState={loading}/>

                                {
                                    loading &&
                                    <SectionSpinner/>
                                }
                                {
                                    !loading &&
                                    <OutlinedButton
                                        text={'Create Session'}
                                        onClick={handleSubmit}
                                        fullWidth
                                        disabled={formDisabled}
                                    />
                                }
                            </FormControl>
                        </Grid>
                    </Grid>
                </Container>
            </>
        )
    }


}

export default ControlForm;